import React from "react";

type FullScreenLoaderProps = {
  isLoading?: boolean;
};

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ isLoading = true }) => {
  if (!isLoading) return null;
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-base-100">
      <div className="flex flex-col items-center gap-4">
        <h1 className="text-base-content text-[12rem] font-light font-groteskLogo leading-none animate-pulse-custom">
          ^
        </h1>
        <p className="-mt-16 text-center font-grotesk text-base-content/70">Loading...</p>
      </div>
    </div>
  );
};

export default FullScreenLoader;
